import { render } from "./DeliveryProviderSettings.vue?vue&type=template&id=997dced0&scoped=true&ts=true"
import script from "./DeliveryProviderSettings.vue?vue&type=script&lang=ts"
export * from "./DeliveryProviderSettings.vue?vue&type=script&lang=ts"

import "./DeliveryProviderSettings.vue?vue&type=style&index=0&id=997dced0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-997dced0"]])

export default __exports__